import FilterDate from '@/Enums/FilterDate.enum';
import { PacingApiStatus } from '@/Enums/Pacing/PacingApiStatus.enum';
import { PacingStatus } from '@/Enums/Pacing/PacingStatus.enum';
import ViewLevel from '@/Enums/Pacing/ViewLevel.enum';
import type { IPacingFilters } from '@/Interfaces/Pacing/Filters.interface';
import type { IGridTotal } from '@/Interfaces/Pacing/GridTotal.interface';
import { DEFAULT_PACING_STATUS_COUNT, PACING_STATUS_LABELS } from '@/constants/pacing';
import { GridFilterOperator, GridRowId, GridValidRowModel } from '@mui/x-data-grid-pro';
import { getDefaultDateRangeFormatted } from '../date/dateRange.helpers';

//#region grid
export const getChartData = (pacingStatuses: PacingStatus[]) => {
  const keys = Object.values(PacingStatus);
  const pacingStatusCount = { ...DEFAULT_PACING_STATUS_COUNT };
  pacingStatuses.forEach(status => {
    pacingStatusCount[status] = pacingStatusCount[status] + 1;
  });

  const datasetData = keys.map(key => pacingStatusCount[key]);

  return {
    labels: keys.map(key => PACING_STATUS_LABELS[key]),
    datasets: [
      {
        data: datasetData,
      },
    ],
  };
};

export const pacingStatusOnlyOperators: GridFilterOperator[] = [
  {
    value: 'lastLevelEqual',
    getApplyFilterFn: filterItem => {
      if (!filterItem.field || !filterItem.value || !filterItem.operator) {
        return null;
      }

      return value => {
        return value === filterItem.value;
      };
    },
  },
];

export const getDefaultFilters = (): IPacingFilters => ({
  level: ViewLevel.LineItem,
  pacingStatus: [],
  status: [PacingApiStatus.ACTIVE],
  ...getDefaultDateRangeFormatted(7),
  dateRangeFormat: FilterDate.LAST_7_DAYS,
  endDate: null,
  whitelabels: [],
  clients: [],
  advertisers: [],
  campaigns: [],
  channels: [],
});

export const getGridTotal = (filterLookup: { id: GridRowId; model: GridValidRowModel }[]): IGridTotal => {
  const totals: IGridTotal = {
    id: 'totals',
    pacingTo: 0,
    booked: 0,
    delivered: 0,
    deliveredToday: 0,
    deliveredYesterday: 0,
    remaining: 0,
  };

  filterLookup.forEach(({ model }) => {
    totals.pacingTo += model.pacingTo ?? 0;
    totals.booked += model.booked ?? 0;
    totals.delivered += model.delivered ?? 0;
    totals.deliveredToday += model.deliveredToday ?? 0;
    totals.deliveredYesterday += model.deliveredYesterday ?? 0;
    totals.remaining += model.remaining ?? 0;
  });
  return totals;
};

export const shouldUpdateTotal = (oldTotal: IGridTotal, newTotal: IGridTotal): boolean => {
  return (Object.keys(oldTotal) as (keyof IGridTotal)[]).some(key => newTotal[key] !== oldTotal[key]);
};
//#endregion
